<template>
  <div>
    <CollectionView :endpoint="utilities.path('communities/@/modules/applications/bans', communityId)" v-model:reload="reload">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <span>{{ translate("bans") }}</span>
          <ButtonView type="normal" color="primary" @click="creating = true">
            {{ translate("create") }}
          </ButtonView>
        </div>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("target") }}</div>
                <div class="table-header-cell">{{ translate("created_at") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">
                    <PlayerView :player="item.target"/>
                  </div>
                  <div class="table-column">
                    {{ utilities.formatDatetime(item.createdAt) }}
                  </div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <TargetedModalHttpFormView size="small" :endpoint="utilities.path('modules/applications/bans/@', item.id)" method="delete" @success="reload = true">
                        <template v-slot:target="{ show }">
                          <ButtonView type="soft" color="danger" size="small" @click="show">
                            <i class="fas fa-trash"></i>
                          </ButtonView>
                        </template>
                        <template v-slot:form="{ submit, loading, hide }">
                          <h2 class="mb-4">{{ item.target.name }}</h2>
                          <SpinnerView :active="loading" color="danger"/>
                          <div class="d-flex align-items-center g-4">
                            <ButtonView type="normal" color="danger" class="w-100" @click="submit">
                              {{ translate("delete") }}
                            </ButtonView>
                            <ButtonView type="normal" color="secondary" class="w-100" @click="hide">
                              {{ translate("cancel") }}
                            </ButtonView>
                          </div>
                        </template>
                      </TargetedModalHttpFormView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalHttpFormView :endpoint="utilities.path('communities/@/modules/applications/bans', communityId)" method="post" v-model:active="creating" @success="reload = true">
      <template v-slot:form="{ content, errors, submit, loading }">
        <div class="d-flex flex-column g-4">
          <PlayerSelectInput v-model:value="content.targetId" :endpoint="utilities.path('communities/@/modules/applications/players/search', communityId)" :title="translate('target')" :errors="errors.targetId" required/>
          <div class="d-flex align-items-center g-4">
            <ButtonView type="normal" color="primary" class="w-100" @click="submit">
              {{ translate("save") }}
            </ButtonView>
            <ButtonView type="normal" color="secondary" class="w-100" @click="creating = false; editing = undefined">
              {{ translate("cancel") }}
            </ButtonView>
          </div>
          <SpinnerView :active="loading" color="primary"/>
        </div>
      </template>
    </ModalHttpFormView>
  </div>
</template>

<script setup>
import {ButtonView, CollectionView, utilities, TargetedModalHttpFormView, SpinnerView, ModalHttpFormView} from "@niftybit/vue";
import PlayerView from "@/components/other/PlayerView.vue";
import PlayerSelectInput from "@/systems/modules/players/PlayerSelectInput.vue";
import {ref} from "vue";

defineProps({
  communityId: String
});

const reload = ref(false);
const creating = ref(false);

</script>